const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaCidade: [],
	filtro: {
		dataInicial: null,
		dataFinal: null,
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'EVENTO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'EVENTO_LISTADO':
			return {
				...state,
				lista: action.payload.data
			};

		case 'EVENTO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'EVENTO_CIDADE_LISTADO':
			return {
				...state,
				listaCidade: action.payload.data
			};
		case 'EVENTO_FILTRO':
			return { ...state, filtro: action.payload };

		default:
			return state;
	}
}